module.exports = __webpack_public_path__ + "img/house4.299106ae.png";